import FormattedMessage from 'I18n/components/FormattedMessage';
import H7 from 'UIComponents/elements/headings/H7';
import { Fragment } from 'react';
// @ts-expect-error Could not find a declaration file for module
import CategoryGroupDropdown from './CategoryGroupDropdown';
import { FILTER_TYPES_OTHER, getCategoryGroup, getToolGroup } from '../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import useMediaQuery from '../hooks/useMediaQuery';
import { device } from '../constants/StyledComponentConstants';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import MobileTopFilterPanel from '../containers/TracksPage/MobileTopFilterPanel';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getSearch, getSelectedCategoryFiltersFromRoute, getSelectedToolFiltersFromRoute
// @ts-expect-error Could not find a declaration file for module
} from '../selectors/routeSelectors';
import { useHistory } from 'react-router-dom';
// @ts-expect-error Could not find a declaration file for module
import CatalogDropdownContainer from './CatalogDropdown/CatalogDropdownContainer';
import MyLearningMobileModal from './Modals/FullScreenModal/MyLearningMobileModal';
import styled, { theme, mediaQuery, css, academyPageFullWidth, academyResultsBar } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ResultsBarContainer = styled.div.withConfig({
  displayName: "ResultsStatusBar__ResultsBarContainer",
  componentId: "suyckq-0"
})(["", " ", " ", ""], academyResultsBar, props => props.sticky === 1 && mediaQuery('notMobile', css(["position:sticky;top:130px;z-index:3;"])), mediaQuery('mobile', css(["height:auto;padding:10px;line-height:1.5;"])));
const ResultsInner = styled.div.withConfig({
  displayName: "ResultsStatusBar__ResultsInner",
  componentId: "suyckq-1"
})(["display:flex;align-items:center;height:100%;", " color:", ";padding-left:48px;padding-right:24px;", " ", ""], academyPageFullWidth, theme.colors.OLAF, mediaQuery('tablet', css(["padding-left:24px;padding-right:12px;"])), mediaQuery('mobile', css(["padding-left:12px;padding-right:0;"])));
const ResultsHeader = styled(H7).withConfig({
  displayName: "ResultsStatusBar__ResultsHeader",
  componentId: "suyckq-2"
})(["margin-bottom:1px;font-weight:500;"]);
const FilterButton = styled(UIButton).withConfig({
  displayName: "ResultsStatusBar__FilterButton",
  componentId: "suyckq-3"
})(["color:", ";width:auto !important;height:60px;margin-top:-12px;margin-bottom:-12px;"], theme.colors.EERIE);
const FilterIcon = styled(UIIcon).withConfig({
  displayName: "ResultsStatusBar__FilterIcon",
  componentId: "suyckq-4"
})(["vertical-align:middle;"]);
const ResultsFlexContainer = styled(UIFlex).withConfig({
  displayName: "ResultsStatusBar__ResultsFlexContainer",
  componentId: "suyckq-5"
})(["font-weight:400;"]);
const TotalsHeading = styled(H7).withConfig({
  displayName: "ResultsStatusBar__TotalsHeading",
  componentId: "suyckq-6"
})(["margin-bottom:0;"]);
const ResultsStatusBar = ({
  startCard,
  endCard,
  mobileFilterTypes = [],
  mobileResultsActions,
  cardsTotal,
  showSort,
  sticky = false,
  showStatusSwitcher,
  loading
}) => {
  const history = useHistory();
  const filterTypeCategories = FILTER_TYPES_OTHER.CATEGORIES;
  const filterTypeTools = FILTER_TYPES_OTHER.TOOLS;
  const selectedCatFilters = useSelector(state => getSelectedCategoryFiltersFromRoute(state, {
    location: history.location
  }));
  const selectedToolFilters = useSelector(state => getSelectedToolFiltersFromRoute(state, {
    location: history.location
  }));
  const selectedSearchTerm = useSelector(state => getSearch(state, {
    location: history.location
  }));
  const selectedTool = [...selectedToolFilters][0];
  const selectedToolGroup = getToolGroup(selectedTool);
  const selectedCategory = [...selectedCatFilters][0];
  const selectedCategoryGroup = getCategoryGroup(selectedCategory);
  const filterType = selectedTool ? filterTypeTools : filterTypeCategories;
  const selectedCat = selectedTool || selectedCategory;
  const selectedGroup = selectedToolGroup || selectedCategoryGroup;
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const [filterPanelOpen, setFilterPanelOpen] = useState(false);
  const getTotals = () => {
    return !cardsTotal ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.filters.noResultsFound"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myLearning.paginatedResultsCount",
      options: {
        startCard,
        endCard,
        cardsTotal
      }
    });
  };
  const getSelectedGroup = () => {
    if (selectedGroup) {
      const groupMessage = filterType === filterTypeTools ? 'softwaregroup' : `${filterType}group`;
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [!isMobile && /*#__PURE__*/_jsx("span", {
          children: ":\xA0"
        }), /*#__PURE__*/_jsx(CatalogDropdownContainer, {
          buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.topFilters.${groupMessage}.${selectedGroup}`
          }),
          inlineLink: true
        }), /*#__PURE__*/_jsx("span", {
          children: "\xA0/\xA0"
        })]
      });
    }
    return '';
  };
  const getSelectedSearchTerm = () => {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [!isMobile && /*#__PURE__*/_jsx("span", {
        children: ":\xA0"
      }), /*#__PURE__*/_jsx("span", {
        children: selectedSearchTerm
      })]
    });
  };
  const getSelectedCategoryText = () => {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [!isMobile && /*#__PURE__*/_jsx("span", {
        children: ":\xA0"
      }), /*#__PURE__*/_jsx(CatalogDropdownContainer, {
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.${filterType}.${selectedCat}`
        }),
        inlineLink: true
      })]
    });
  };
  const renderGroupAndDropdown = () => {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [getSelectedGroup(), isMobile ? /*#__PURE__*/_jsx(CatalogDropdownContainer, {
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.${filterType}.${selectedCategory}`
        }),
        inlineLink: true,
        selectedFilterType: filterType,
        selectedGroup: selectedGroup
      }) : /*#__PURE__*/_jsx(CategoryGroupDropdown, {
        filterType: filterType,
        selectedCategory: selectedCat,
        selectedGroup: selectedGroup
      })]
    });
  };
  const renderLearningPage = () => {
    return isMobile && /*#__PURE__*/_jsx(MyLearningMobileModal, {});
  };
  const getResultsDetail = () => {
    return /*#__PURE__*/_jsx(Fragment, {
      children: selectedGroup ? renderGroupAndDropdown() : selectedCat ? getSelectedCategoryText() : selectedSearchTerm ? getSelectedSearchTerm() : showStatusSwitcher ? renderLearningPage() : ''
    });
  };
  const StyledFilterButtonMessage = styled(FormattedMessage).withConfig({
    displayName: "ResultsStatusBar__StyledFilterButtonMessage",
    componentId: "suyckq-7"
  })(["color:", ";"], theme.colors.EERIE);
  const renderFilterButton = () => {
    return /*#__PURE__*/_jsxs(FilterButton, {
      "data-test-id": "mobile-filter-panel-button",
      onClick: () => setFilterPanelOpen(true),
      use: "transparent",
      children: [/*#__PURE__*/_jsx(StyledFilterButtonMessage, {
        message: "learningCenter.filters.filtersLink"
      }), /*#__PURE__*/_jsx(FilterIcon, {
        color: theme.colors.EERIE,
        name: "filter",
        size: 22
      })]
    });
  };
  const renderMobileResults = () => {
    if (loading) return;
    return /*#__PURE__*/_jsxs(ResultsFlexContainer, {
      align: "center",
      children: [/*#__PURE__*/_jsxs(UIBox, {
        grow: 2,
        children: [/*#__PURE__*/_jsx(TotalsHeading, {
          children: getTotals()
        }), getResultsDetail(), mobileResultsActions]
      }), mobileFilterTypes && mobileFilterTypes.length > 0 && renderFilterButton()]
    });
  };
  const renderResults = () => {
    if (loading) return;
    return /*#__PURE__*/_jsxs(ResultsInner, {
      children: [/*#__PURE__*/_jsx(ResultsHeader, {
        children: getTotals()
      }), getResultsDetail()]
    });
  };
  return /*#__PURE__*/_jsxs(ResultsBarContainer, {
    sticky: sticky ? 1 : 0,
    children: [isMobile ? renderMobileResults() : renderResults(), isMobile && /*#__PURE__*/_jsx(MobileTopFilterPanel, {
      "data-test-id": "mobile-secondary-filter-panel",
      itemsCount: cardsTotal || 0,
      mobileFilterTypes: mobileFilterTypes,
      onCloseClick: () => setFilterPanelOpen(false),
      open: filterPanelOpen,
      showSort: showSort
    })]
  });
};
export default ResultsStatusBar;